<template>
  <div class="modal-modify-store">
    <el-dialog
      :title="title"
      :visible.sync="visible"
      @close="$_cancle"
      lock-scroll
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="greater"
    >
      <div class="content">
        <el-form
          ref="modifyStore"
          :rules="rules"
          v-loading="isLoading"
          label-position="right"
          :model="formData"
          class="platform-modify__form"
        >
          <el-form-item label="所属品牌:">
            <el-input
              :disabled="true"
              v-model="formData.brandName"
              placeholder="必选, 单选"
              style="width: 440px"
            ></el-input>
            <el-button
              v-if="formType === 'add'"
              @click="$_select"
              class="select__btn"
              >选择</el-button
            >
          </el-form-item>

          <el-form-item label="门店id:" prop="storeId">
            <el-input
              v-model="formData.storeId"
              placeholder="选填, 请输入门店id"
              style="width: 440px"
            ></el-input>
          </el-form-item>

          <el-form-item label="门店名称:" prop="storeName">
            <el-input
              v-model="formData.storeName"
              placeholder="必填, 请输入门店名称"
              style="width: 440px"
            ></el-input>
            <span class="input-tips"
              >*支持25个中文字符或50个英文字符,
              允许输入/'*&^"#!$之外的特殊符号</span
            >
          </el-form-item>

          <el-form-item
            v-if="formType === 'edit' && unifiedSwitch"
            label="共享门店ID:"
            prop="sscStoreId"
          >
            <el-input
              v-model="formData.sscStoreId"
              placeholder="必填"
              style="width: 291px"
            ></el-input>
            <div class="input-tips">切勿随便更改，修改会影响SPAS的门店映射</div>
          </el-form-item>

          <el-form-item label="备注:" prop="note" type="textarea">
            <el-input
              :disabled="formType === 'read'"
              type="textarea"
              style="width: 500px; height: 48px"
              resize="none"
              placeholder="选填"
              v-model="formData.note"
            ></el-input>
            <span class="input-tips">*最多支持50个字符</span>
          </el-form-item>

          <div class="base-box">
            <div class="b-title">门店基础信息</div>
            <div class="row-flex">
              <el-form-item label="省份:" prop="provinceCode">
                <el-select
                  :disabled="formType === 'read'"
                  style="width: 180px"
                  v-model="formData.provinceCode"
                  filterable
                  placeholder="全部"
                  @change="$_provincesChange"
                  :popper-append-to-body="false"
                >
                  <el-option value="">省份</el-option>
                  <el-option
                    v-for="item in provinces"
                    :key="item.id"
                    :label="item.regionName"
                    :value="item.regionCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="城市:" prop="cityCode">
                <el-select
                  :disabled="formType === 'read'"
                  style="width: 180px"
                  v-model="formData.cityCode"
                  filterable
                  placeholder="全部"
                  @change="$_citysChange"
                  :popper-append-to-body="false"
                >
                  <el-option value="">城市</el-option>
                  <el-option
                    v-for="item in citys"
                    :key="item.id"
                    :label="item.regionName"
                    :value="item.regionCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="行政区域:" prop="areaCode">
                <el-select
                  :disabled="formType === 'read'"
                  style="width: 180px"
                  v-model="formData.areaCode"
                  filterable
                  placeholder="全部"
                  :popper-append-to-body="false"
                >
                  <el-option value="">区域</el-option>
                  <el-option
                    v-for="item in districts"
                    :key="item.id"
                    :label="item.regionName"
                    :value="item.regionCode"
                  >
                  </el-option>
                </el-select>
                <span class="input-tips">*选填，不填写则没有省市区数据</span>
              </el-form-item>
            </div>
            <div class="row-flex">
              <el-form-item label="经度:">
                <el-input
                  :disabled="formType === 'read'"
                  v-model="formData.longitude"
                  placeholder="请输入"
                  style="width: 180px"
                ></el-input>
              </el-form-item>
              <el-form-item label="纬度:">
                <el-input
                  :disabled="formType === 'read'"
                  v-model="formData.latitude"
                  placeholder="请输入"
                  style="width: 180px"
                ></el-input>
                <span class="input-tips">*选填，不填写则无法定位门店数据</span>
              </el-form-item>
            </div>

            <div class="row-flex" style="margin-top: 10px">
              <el-form-item label="门店电话:" prop="telePhone">
                <el-input
                  :disabled="formType === 'read'"
                  v-model="formData.telePhone"
                  placeholder="请输入门店电话"
                  style="width: 440px"
                ></el-input>
                <span class="input-tips">*选填</span>
              </el-form-item>
            </div>
            <div class="row-flex">
              <el-form-item label="门店地址:">
                <el-input
                  :disabled="formType === 'read'"
                  v-model="formData.address"
                  placeholder="请输入门店地址"
                  style="width: 440px"
                ></el-input>
                <span class="input-tips">*选填，不填写则没有门店地址</span>
              </el-form-item>
            </div>
            <el-form-item label="门店IM系统:">
              <el-select
                style="width: 180px"
                v-model="formData.imSystem"
                filterable
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in stores.getAllImSystemConfList"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer" v-if="formType !== 'read'">
        <el-button class="save__btn" @click="$_submit">保存</el-button>
        <el-button class="cancel__btn" @click="$_cancle">取消</el-button>
      </div>

      <select-brand
        v-if="modal.show === true && modal.template === 'select-brand'"
        :title="modal.title"
        :selected="modal.data"
        :customClass="'greater'"
        @callback="$_callbackBrand"
        @close="$_close"
      ></select-brand>
    </el-dialog>
    <merge-store
      v-if="modal.show && modal.template === 'merge-store'"
      :modalData="modal.data"
      @callback="$_callbackMergeStore"
      @close="$_close"
    ></merge-store>
  </div>
</template>
<script>
import * as Utils from "@/plugins/utils";
import SelectBrand from "@/components/modal-select-brand";
import MergeStore from "./modal-merge-store.vue";
import { mapGetters } from "vuex";
const validName = (rule, value, callback) => {
  if (value) {
    if (Utils.getStrLength(value) > 50) {
      callback(new Error("25个中文字符或50个英文字符"));
    } else if (value.match(/[/\'*&^"#!$]/i) != null) {
      callback(new Error(`请输入除/\'*&^"#!$之外的符号`));
    } else {
      callback();
    }
  }
  callback();
};
export default {
  name: "modal-modify-store",
  props: {
    title: { type: String, default: "" },
    formType: { type: String, default: "add" },
    modalData: { type: Object, default: {} },
  },
  inject: ["stores"],
  data() {
    return {
      visible: false,
      isLoading: false,
      provinces: [], //省份列表
      citys: [], //城市列表
      districts: [], //地区列表
      sscBrandId: 0, // 共享品牌id
      formData: {
        shopId: -1,
        brandId: 0,
        brandName: "", // 品牌名称
        storeName: "",
        storeId: "",
        note: "", // 备注
        imSystem: "default", // 门店IM系统
        provinceCode: "", // 省份
        cityCode: "", // 城市
        areaCode: "", // 行政区域
        longitude: "", //经度
        latitude: "", //纬度
        telePhone: "", //门店电话
        address: "", //门店地址
      },
      modal: {
        show: false,
        title: "",
        template: "",
        data: {},
      },
      rules: {
        brandName: [
          { required: true, message: "请选择品牌名称", trigger: "blur" },
        ],
        storeName: [
          { required: true, message: "请输入门店名称", trigger: "blur" },
          { validator: validName, trigger: "blur" },
        ],
        storeId: [
          { validator: Utils.validID, trigger: "blur" },
          { validator: Utils.validCharmap, trigger: "blur" },
        ],
        sscStoreId: [
          { required: true, message: "请输入共享门店id", trigger: "blur" },
        ],
        note: [
          {
            validator: (rule, value, callback) => {
              if (value && value.length > 50) {
                callback(new Error("最多50个字符!"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        telePhone: [
          {
            validator: (rule, value, callback) => {
              if (value) {
                let reg =
                  /^(1[3-9]\d{9}|([\(（]?0[0-9]{2,3}[）\)]?[-]?)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?)$/;
                if (!reg.test(value)) {
                  callback(new Error("请输入正确的电话号码"));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      unifiedSwitch: "unifiedSwitch",
    }),
  },
  watch: {
    "formData.provinceCode"(val) {
      if (val != "") {
        this.$service
          .post("getRegionData", {
            level: "city",
            parentRegionCodeId: -1,
            parentRegionCode: val,
          })
          .then((result) => {
            if (result.$.checkResult(result, true)) {
              this.citys = result.data.map((ele) => {
                ele.id = ele.id + "";
                return ele;
              });
            }
          });
      } else {
        this.citys = [];
      }
    },
    "formData.cityCode"(val) {
      if (val != "") {
        this.$service
          .post("getRegionData", {
            level: "area",
            parentRegionCodeId: -1,
            parentRegionCode: val,
          })
          .then((result) => {
            if (result.$.checkResult(result, true)) {
              this.districts = result.data.map((ele) => {
                ele.id = ele.id + "";
                return ele;
              });
            }
          });
      } else {
        this.districts = [];
      }
    },
  },
  methods: {
    $_provincesChange(val) {
      //重置
      this.formData.cityCode = "";
      this.formData.areaCode = "";
    },
    $_citysChange(val) {
      //重置
      this.formData.areaCode = "";
    },
    // 点击选择品牌按钮事件
    $_select() {
      // 处理已选择的品牌数据
      this.modal.data = {
        brandId: this.formData.brandId,
      };
      this.modal.title = "选择品牌";
      this.modal.template = "select-brand";
      this.modal.show = true;
    },
    // 选择品牌回调
    $_callbackBrand(data) {
      let { brandId, brandName, sscBrandId } = data;
      this.formData.brandId = brandId;
      this.formData.brandName = brandName;
      this.sscBrandId = sscBrandId;
    },
    // 合并弹窗成功回调
    $_callbackMergeStore() {
      this.$_close();
      this.$emit("callback");
    },
    // 关闭选择品牌
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.title = "";
      this.modal.data = {};
    },
    $_submit() {
      if (!this.formData.brandId) {
        $MessageBox.alert({ content: "请选择所属品牌" });
        return false;
      }
      this.$refs["modifyStore"].validate((valid, object) => {
        if (valid) {
          const self = this;
          if (self.formType === "add") {
            $MessageBox.confirm({
              content: "是否确认添加门店，结果会同步所有系统的同一个门店",
              onOk() {
                self.saveAction();
              },
            });
          } else {
            $MessageBox.confirm({
              content: "是否确认编辑门店，结果会同步所有系统的同一个门店",
              onOk() {
                self.saveAction();
              },
            });
          }
        }else{
          const errorDiv = document.getElementsByClassName('is-error')
          errorDiv[0] && errorDiv[0].scrollIntoView()
        }
      });
    },

    // 保存接口逻辑方法
    async saveAction() {
      this.isLoading = true;
      try {
        let action = this.formType === "add" ? "addStore" : "editStore";
        let {
          brandId,
          brandName,
          storeName,
          storeId,
          note,
          shopId,
          provinceCode,
          cityCode,
          areaCode,
          longitude,
          latitude,
          telePhone,
          address,
          imSystem,
        } = this.formData;
        let postData = {
          brandId,
          brandName,
          storeName,
          storeId,
          note,
          provinceCode,
          cityCode,
          areaCode,
          longitude,
          latitude,
          telePhone,
          address,
          imSystem,
        };

        // 如果是新增，则传 merged 和 sscStoreId, 如果是编辑，则传 id 和 sscStoreId
        if (this.formType === "add") {
          Object.assign(postData, {
            sscBrandId: this.sscBrandId,
          });
        } else if (this.formType === "edit") {
          Object.assign(postData, {
            shopId,
            sscStoreId: this.formData.sscStoreId,
          });
        }

        const self = this;
        await this.$service.post(action, postData).then((result) => {
          // 如果返回的状态码是30，则显示合并弹窗
          if (result.status === 30) {
            self.modal = {
              show: true,
              template: "merge-store",
              data: {
                ...postData,
              },
            };
          } else if (result.$.checkResult(result, true)) {
            $MessageBox.alert({
              content: result.msg,
              onOk() {
                self.visible = false;
                self.$emit("callback");
              },
            });
          }
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },

    $_cancle() {
      this.visible = false;
      this.$emit("close");
    },
  },
  async created() {
    this.isLoading = true;
    try {
      await this.$service
        .post("getRegionData", {
          level: "province",
          parentRegionCodeId: -1,
        })
        .then((result) => {
          if (result.$.checkResult(result, true)) {
            this.provinces = result.data.map((ele) => {
              ele.id = ele.id + "";
              return ele;
            });
          }
        });
      if (this.formType !== "add") {
        await this.$service
          .post("getStoreDetail", {
            shopId: this.modalData.shopId,
          })
          .then((result) => {
            if (result.$.checkResult(result, true)) {
              this.formData = result.data;
            }
          });
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.isLoading = false;
    }
  },
  mounted() {
    this.visible = true;
  },
  components: {
    SelectBrand,
    MergeStore,
  },
};
</script>

<style lang="scss" scoped>
.platform-modify__form {
  padding: {
    left: 20px;
  }
}
.content {
  padding: 20px 20px;
  .title {
    height: 32px;
    color: #384e8c;
    font-size: 14px;
    font-weight: 700;
  }
  .base-box {
    padding-top: 10px;
    .row-flex {
      display: flex;
      // padding-left: 30px;
      .el-form-item {
        margin-right: 30px;
      }
      /deep/ .el-select {
        .el-popper {
          .el-select-dropdown__wrap {
            max-height: 200px;
          }
        }
      }
    }
  }
  .b-title {
    color: #3a3a3a;
    font-size: 12px;
    font-weight: bold;
    line-height: 100%;
    padding-bottom: 10px;
    margin-bottom: 14px;
    border-bottom: 1px solid #dcdcdc;
  }
  .business-hours {
    width: 600px;
    padding: 10px 0 0;
    .b-title {
      border: none;
      margin-bottom: 0;
      font-weight: normal;
      color: #68768a;
      .input-tips {
        color: #aaaaaa;
        font-size: 12px;
      }
    }
    .block {
      position: relative;
      overflow: auto;
      max-height: 310px;
      .item {
        width: 570px;
        background-color: #f5f5f6;
        border: 1px solid #eee;
        padding: 8px 40px 0px 20px;
        margin-bottom: 10px;
        position: relative;
        &:last-child {
          margin-bottom: 0;
        }
        .check-box {
          display: flex;
        }
        .el-checkbox-group {
          flex: 1;
          overflow: hidden;
          max-width: 460px;
          .el-checkbox {
            margin: 0 68px 6px 0;
            color: #535353;
            line-height: 100%;
            &:nth-child(4) {
              margin-right: 0;
            }
          }
        }
        .label {
          white-space: nowrap;
          margin-right: 5px;
          color: #535353;
        }
        .select-time {
          width: 378px;
          display: flex;
          line-height: 28px;
          margin-bottom: 8px;
          .split {
            display: block;
            margin: 0 6px;
          }
          .el-form-item {
            margin-bottom: 0;
            width: 110px;
          }
          .el-button {
            margin-top: 1px;
          }
        }
        .el-button {
          margin-left: 10px;
          width: 25px;
          height: 25px;
          border-radius: 3px;
          padding: 0;
          /deep/ .cd-icon__add {
            transform: scale(0.6);
          }
        }
        .btn-add {
          background: #1895dd;
        }
        .btn-del {
          background: #9fa4a9;
        }
        .opera-box {
          position: absolute;
          right: 0;
          top: 0;
          bottom: 0;
          border-left: 1px solid #eee;
          width: 40px;
          .el-button {
            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
      .input-tips {
        position: absolute;
        left: 510px;
        top: 10px;
        width: 150px;
        text-align: justify;
        line-height: 14px;
        color: #aaa;
        word-break: break-all;
      }
    }
  }
}
.select__btn {
  margin-left: 8px;
}
.input-tips {
  margin-left: 10px;
}
</style>
